//  Link media
require.context('../media/', true, /^\.\/.*\.*/);
require.context('../fonts/', true, /^\.\/.*\.*/);

//  Styles
import '../styles/styles.scss';

// JS
import lazysizes, { init } from 'lazysizes';
import utils from './proj/utils';

import $ from 'jquery';
// import Tracker from './proj/Tracker';
import "intersection-observer";
import scrollama from 'scrollama';
import { array } from 'prop-types';
import textBalancer from 'text-balancer';

import vapor from './proj/vapor.js';

// const tracker = new Tracker('');

let charlestonScroller = scrollama();
let cycloneScroller = scrollama();

const charlestonUpdate = function(e) {
    const stepIndex = e.element.dataset.step;
    const mapLayers = document.querySelectorAll('.map-step');
    if (stepIndex) {
        mapLayers.forEach(i => {
            i.classList.add('hidden');
            if (i.dataset.step == stepIndex) {
                i.classList.remove('hidden')
            }
        })
    }
}

const cycloneUpdate = function(e) {
    const stepLabel = e.element.dataset.step;
    const layerTwo = document.querySelector('.image-step');
    if ( (stepLabel == 'warm-water') && (e.direction == 'down') ) {
        layerTwo.classList.remove('hidden');
    } else if ( (stepLabel == 'cool-water') && (e.direction == 'up') ) {
        layerTwo.classList.add('hidden');
    }
}


$(document).ready(function() {

    $('body').addClass('start-app');

    // lazy sizes config
    lazysizes.cfg.customMedia = {
        '--device': '(max-width: 800px)',
        '--laptop': '(max-width: 1200px)',
        '--desktop': '(max-width: 1440px)',
    };


    let aTags = document.querySelectorAll('a[href]');
    aTags.forEach(a => {
        if (!a.getAttribute('href').startsWith('#')) {
            a.setAttribute('target', '_blank');
        }
    });

    textBalancer.balanceText('.pg-title');
    textBalancer.balanceText('.pg-subhed');

    charlestonScroller.setup({
        container: '#scroller-container',
        graphic: '#scroller-graphic',
        text: '#scroller-content',
        step: '.step',
        offset: 0.75
    })
    .onStepEnter(charlestonUpdate);

    charlestonScroller.resize();

    cycloneScroller.setup({
        container: '#cyclone-container',
        graphic: '#cyclone-graphic',
        text: '#cyclone-scroller-content',
        step: '.step',
        offset: 0.75
    })
    .onStepEnter(cycloneUpdate);

    cycloneScroller.resize();


    vapor();
});








const zionKeys = {
    "Dev":"KpBwC22cgTOQ5OFcXlXpBCcQ4T8dO1i6",
    "Ref":"8t39z2GbZJqhKdMoQqsNiIv3DbTJtAWD",
    "Stage":"6SJTYyRg7GWdXGtZb5Hf6vv0pWAIyPvG",
    "Prod":"mXFw59FFEpUNOu3aeVJChKAsqAlZ4NEf"
}
const detectEnvironment = () => {
    let url = window.location.href;
    if (url.indexOf("edition.cnn.com") > 0 || url.indexOf("www.cnn.com") > 0) {
        return 'Prod';
    } else if (url.indexOf("cnnpreview") > 0 || url.indexOf("cnn-interactive") > 0) {
        return 'Stage';
    } else {
        return 'Dev';
    }
}

const isMobileDevice = utils.mobileAndTabletCheck();
const isMobile = window.innerWidth < 800 || isMobileDevice;
const zionEnv = detectEnvironment();

if (window.ZION_SDK) {
    var zion = new window.ZION_SDK.ZionAnalytics(
    window.ZION_SDK.ClientType.Web, // * legacy, this will always be Web
    window.ZION_SDK.EnvironmentType[zionEnv], // Identity bridge value. See https://github.com/turnercode/zion-suite/tree/master/packages/ZionAnalytics#parameters for values
    {
        enabled: true, // Analytics functionality flag
        bridgeEnabled: true, // Id bridge functionality flag
        enableLogging: false, // this turns on and off debug logs
        accessKey: zionKeys[zionEnv], // This is the appropriate Key for segment, Ask the Data core team for the keys if you do not have them
    },
);

// here you track a new pageview element
// the constructor for the Pageview is provided by the SDK
// to see other event types see http://zion.cnnio.net/
zion.track(
    new window.ZION_SDK.Pageview({
        sourceId: 'interactive_sotu-address-annotated',
        hypatiaId: 'h_1',
        canonicalUrl: window.location.href,
    }),
);
}



// WEBPACK FOOTER //
// ./src/js/main.js